import { render, staticRenderFns } from "./UserSetting.vue?vue&type=template&id=01ba775b&scoped=true&"
import script from "./UserSetting.vue?vue&type=script&lang=js&"
export * from "./UserSetting.vue?vue&type=script&lang=js&"
import style0 from "./UserSetting.vue?vue&type=style&index=0&id=01ba775b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ba775b",
  null
  
)

export default component.exports